<template>
  <div class="container">
    <div ref="containerRef"></div>
  </div>
</template>

<script setup>
import { defineProps, onMounted, ref } from "vue";
import { runScrollMagic } from "../utils/scroll";
import { t } from "@/locales"

const props = defineProps({
  data: Object,
  replaceData: {
    type: Object,
    default: () => ({})
  },
});

let containerRef = ref(null);
let scene = null;

onMounted(() => {
  pixiRun();
});

function pixiRun() {
  const data = props.data;
  const replaceData = props.replaceData;
  if (!data) {
    return
  }

  if (scene) {
    // reset pixi
    scene.view.remove();
    scene.destroy();
    scene = null;
  }

  // Scene: Extends the PIXI.Application class to provide easy loading.
  // https://pixijs.download/dev/docs/PIXI.Application.html
  scene = new PIXI.animate.Scene({
    // view: document.getElementById("stage"),
    width: data.width,
    height: data.height,
    // backgroundColor: 'transparent',
    transparent: true,
    antialias: true,
    preserveDrawingBuffer: true,
    // autoStart: false, // not auto
  });
  // for mobile scroll
  scene.view.style.maxWidth = "100%";
  scene.view.style.touchAction = "auto";
  scene.view.style.pointerEvents = "none";

  // aad i18n 確定語系之後才load
  PIXI.animate.Text = class extends PIXI.animate.Text {
    constructor(text) {
      super(replaceData[text] ?? t(text));
    }
  };
  
  data.setup(PIXI.animate);

  // dynamic append canvas
  containerRef.value.appendChild(scene.view);
  // change order prevent view dom not found
  scene.load(data, complete);
  // console.log('scene', document.body.contains(scene.view))
  function complete(mc) {
    // mc.stop();    
    // reset scroll magic
    if (data._controller) {
      data._controller.destroy(true);
      data._controller = null;
    }
    // custom filed _controller
    data._controller = runScrollMagic(scene.view, mc, data);
  }
}
</script>
<style scoped>

</style>
